export default __webpack_public_path__ + "static/media/1.a14a7523.png";